import { InAppMessagePresentationContext } from "../../../present/presentation/InAppMessagePresentationContext"
import { InAppMessageUi } from "../../InAppMessageUi"
import { InAppMessageViewStatus } from "../InAppMessageViewStatus"
import { HtmlInAppMessageRenderer } from "./HtmlInAppMessageRenderer"
import { InAppMessageHtmlContentResolver } from "../../html/InAppMessageHtmlContentResolver"
import Logger from "../../../../../core/internal/logger"
import { Callback } from "../../../../../core/internal/util/Callback"
import { Promises } from "../../../../../core/internal/util/Promises"
import { InAppMessageBridge } from "../../html/InAppMessageBridge"
import { InAppMessageView } from "../InAppMessageView"
import { InAppMessageBaseView } from "../InAppMessageBaseView"

export class HtmlInAppMessageView extends InAppMessageBaseView implements InAppMessageView {
  private static OPEN_TIMEOUT_MILLIS = 5000

  constructor(
    public readonly context: InAppMessagePresentationContext,
    public readonly ui: InAppMessageUi,
    public readonly status: InAppMessageViewStatus,
    private readonly htmlResolver: InAppMessageHtmlContentResolver,
    private readonly renderer: HtmlInAppMessageRenderer,
    private readonly bridge: InAppMessageBridge
  ) {
    super(context, ui, status)
  }

  private async render(htmlContent: string) {
    return new Promise<void>((resolve, reject) => {
      const onReadyCallback = new Callback(() => {
        resolve()
      })

      try {
        this.renderer.render(htmlContent, this.bridge, onReadyCallback)
      } catch (err) {
        reject(err)
      }
    })
  }

  async open(): Promise<void> {
    if (!this.canOpen()) {
      Logger.log.debug(`InAppMessage is already opened. (key=${this.context.inAppMessage.key})`)
      return
    }

    try {
      this.handleOpenStarted()
      const htmlContent = await this.htmlResolver.resolve(this.context)
      await Promises.timeout(this.render(htmlContent), HtmlInAppMessageView.OPEN_TIMEOUT_MILLIS)
      this.handleOpenCompleted()
    } catch (error) {
      this.handleOpenFailed(error)
    }
  }

  close(): void {
    if (!this.canClose()) {
      Logger.log.debug(`InAppMessage is already closed. (key=${this.context.inAppMessage.key})`)
      return
    }

    try {
      this.handleCloseStarted()
      this.handleCloseCompleted()
    } catch (error) {
      this.handleCloseFailed(error)
    }
  }

  destroy(): void {
    this.renderer.destroy()
    this.ui.currentMessageView = null
    this.status.current = "CLOSED"
  }
}
